export const usePage = () => useState('page');